module.exports = __webpack_public_path__ + "images/FUSA_icons/039-online-shop-9.43613a68d2168911275826030aa5bc6a.svg";